import React from "react";

// Create user context instance to later provide in App.js and use throughout application. Holds auth user

const UserContext = React.createContext();

export default UserContext;